import { createId } from '@paralleldrive/cuid2';
import { timestamp } from './utils/Time';

type ActivitySessionInput = {
  activitySessionId?: string;
};

export class ActivitySession {
  activitySessionId: string;
  startTime?: number;
  endTime?: number;
  duration?: number;
  signalingCount: number = 0;

  constructor(input?: ActivitySessionInput) {
    this.activitySessionId = input?.activitySessionId || createId();
  }

  end() {
    this.endTime = timestamp();
    this.duration = this.endTime - this.startTime!;
  }

  start() {
    this.startTime = timestamp();
  }

  signal() {
    this.signalingCount++;
  }
}
